import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';

/**
 * Footer 영역 표시/숨김 제어 컴포넌트
 * - themeConfig.footerEnabled 값을 토글로 제어합니다.
 * - footerEnabled가 false가 아닌 경우(미설정 포함) 표시로 간주합니다.
 */
const FooterEnabledControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};
  const footerEnabled = currentThemeConfig.footerEnabled !== false;

  return (
    <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>Footer 영역 표시:</label>
        <label
          style={{
            position: 'relative',
            display: 'inline-block',
            width: '50px',
            height: '24px',
            cursor: 'pointer'
          }}
        >
          <input
            type="checkbox"
            checked={footerEnabled}
            onChange={(e) => {
              set('footerEnabled', e.target.checked);
            }}
            style={{
              opacity: 0,
              width: 0,
              height: 0
            }}
          />
          <span
            style={{
              position: 'absolute',
              cursor: 'pointer',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: footerEnabled ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
              transition: '0.3s',
              borderRadius: '24px'
            }}
          >
            <span
              style={{
                position: 'absolute',
                height: '18px',
                width: '18px',
                left: '3px',
                bottom: '3px',
                backgroundColor: 'white',
                transition: '0.3s',
                borderRadius: '50%',
                transform: footerEnabled ? 'translateX(26px)' : 'translateX(0)'
              }}
            />
          </span>
        </label>
      </div>
      <div style={{ fontSize: '11px', color: '#666' }}>
        {footerEnabled ? '활성화됨' : '비활성화됨'} - 사이트 하단 Footer 영역을 표시하거나 숨깁니다
      </div>
    </div>
  );
};

export default FooterEnabledControl;
